module.exports = __webpack_public_path__ + "static/media/no_docs.158e6052.png";